module.exports = __webpack_public_path__ + "assets/img/test3.7c76101b.svg";